import { render, staticRenderFns } from "./campusCen.vue?vue&type=template&id=7ef73d20&scoped=true&"
import script from "./campusCen.vue?vue&type=script&lang=js&"
export * from "./campusCen.vue?vue&type=script&lang=js&"
import style1 from "./campusCen.vue?vue&type=style&index=1&id=7ef73d20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef73d20",
  null
  
)

export default component.exports